import React, { Fragment, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import paginate from 'paginate-array';

import { Input, Pagination } from 'components';
import defaultBag from 'constants';

import messages from 'messages';

function ReviewContainer({ ...props }) {
    const queryClient = useQueryClient();

    const bag = queryClient.getQueryData('bag') || defaultBag;
    const currency = queryClient.getQueryData('restaurant')?.currency || 'EUR';

    const { formatMessage } = props.intl;

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const renderType = (item) => {
        if (item.type === 'amount') {
            return `${currency.toUpperCase()} ${item.amount} - (${formatMessage(messages.genericLabelAmount)})`;
        }

        return `${item.name} - (${formatMessage(messages.genericLabelExperience)})`;
    }

    const { data, total } = paginate(bag, page, rowsPerPage);

    return (
        <div className="list-items">
            {data.map((el, index) => (
                <Fragment key={index}>
                    {el.recipients?.map((recipient, i) => (
                        <div className="item" key={i}>
                            <div className="review-item">
                                <p className="label">{formatMessage(messages.recipientLabel)}</p>
                                <p className="value">
                                    {recipient.name}
                                    <span>{recipient.email}</span>
                                </p>
                            </div>

                            <div className="review-item">
                                <p className="label">{formatMessage(messages.genericType)}</p>
                                <p className="value">{renderType(el)}</p>
                            </div>

                            <div className="review-item message">
                                <p className="label">{formatMessage(messages.genericMessageForReceiver)}</p>

                                <Input data-test="message-field" id="message" type="textarea" maxLength={1000} value={recipient.message} disabled={true} />
                            </div>

                            <hr className="horizontal-bar" />
                        </div>
                    ))}
                </Fragment>
            ))}

            {(total > rowsPerPage) ? (

                <Pagination
                    type="review"
                    initialPage={page}
                    items={total}
                    initialRowsPerPage={rowsPerPage}
                    onChangePageCallback={(page) => setPage(page)}
                    onChangeRowsPerPageCallback={(rowsPerPage) =>
                        setRowsPerPage(rowsPerPage)
                    }
                />
            ) : ''}

        </div>
    );
}

export default injectIntl(ReviewContainer);
